import { render } from "./PaymentMethods.vue?vue&type=template&id=7d3875f6&ts=true"
import script from "./PaymentMethods.vue?vue&type=script&lang=ts"
export * from "./PaymentMethods.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__